import React from 'react'
import { match } from 'ts-pattern'

import { useEmployerTitle } from '@frame/lib/hooks/useEmployerTitle'
import { ItemKind } from '@frame/lib/hooks/useGetItems'

type Props = {
  kind: ItemKind
}

export function NoResults({ kind }: Props) {
  const { getEmployerTitle } = useEmployerTitle()
  return match(kind)
    .with(ItemKind.PLATFORM, ItemKind.BENEFITS, () => (
      <div className="mt-4 flex flex-col justify-between text-center">
        <p className="mt-5 text-sm font-medium text-moss-700">No results found.</p>
        <p className="mt-3 text-sm text-moss-500">
          If you can’t find the payroll provider, Truework or {getEmployerTitle({ possessive: true })} will try to
          verify another way.
        </p>
      </div>
    ))
    .with(ItemKind.EMPLOYER, ItemKind.GIG, () => (
      <div className="mt-4 flex flex-col justify-between text-center">
        <p className="mt-5 text-sm font-medium text-moss-700">No results found.</p>
        <p className="mt-3 text-sm text-moss-500">
          Not all employers are listed here. If you can’t find your employer, you can verify another way.
        </p>
      </div>
    ))
    .with(ItemKind.INCOME, () => (
      <div className="mt-4 flex flex-col justify-between text-center">
        <p className="mt-5 text-sm font-medium text-moss-700">No results found.</p>
        <p className="mt-3 text-sm text-moss-500">
          If you can’t find the corresponding income stream, Truework or {getEmployerTitle({ possessive: true })} will
          try to verify another way.
        </p>
      </div>
    ))
    .exhaustive()
}
